import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    permissionList: []  // 可操作权限列表
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
